// Prigmar's official public contact details + social links rendered in the
// site footer (FooterComponent). The social URLs are NOT hand-typed: they are
// derived from the SELECTED social targets connected to the "Prigmar" brand in
// production (the exact accounts Prigmar posts to), so the footer buttons point
// at the real Prigmar profiles instead of the stale links that used to live
// here (prigmarcom / prigmarUSA / a BidLight LinkedIn authwall / the wrong
// YouTube channel).
//
// Source of truth — brand "Prigmar", selected SocialTargets:
//   facebook  page    107649827545139           -> /107649827545139
//   twitter   account @Prigmar_media            -> x.com/Prigmar_media
//   linkedin  org     105361514                 -> /company/105361514
//   youtube   channel UCZwjDEiYoUtfFHNppMJtXpA  -> /channel/UCZwjDEiYoUtfFHNppMJtXpA
//
// Phone is Prigmar's published support number (4808594697).

export const PRIGMAR_PHONE = "+1 480 859 4697";
export const PRIGMAR_PHONE_TEL = "tel:+14808594697";

export const PRIGMAR_SOCIAL = {
  facebook: "https://www.facebook.com/107649827545139",
  twitter: "https://x.com/Prigmar_media",
  linkedin: "https://www.linkedin.com/company/105361514",
  youtube: "https://www.youtube.com/channel/UCZwjDEiYoUtfFHNppMJtXpA",
};
